(function ($) {
  $(function () {
    $(window).on("load", function () {
      setTimeout(function () {
        // Force external links to open in new tab / window
        var siteName = window.location.host.replace("www.", "");
        $('a[href^="htt"]:not([target]):not([href*="www.' + siteName + '"]):not([href*="//' + siteName + '"]):not([class*="fancybox"])').attr("target", "_blank").attr("rel", "noreferrer, noopener");
      }, 1000);

      setTimeout(function () {
        if ($(".ua-safari").length > 0) {
          $("body").addClass("scroll-active");
        }
      }, 100);
      wow.init();
    });

    var wow = new WOW({
      boxClass: "wow",
      offset: 100,
      mobile: true,
      live: true,
      callback: function (box) {
        $(box).addClass("animate-complete");
      },
    });
    wow.init();

    function scroll_ani() {
      $('footer li a[href^="#"]').on("click", function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop: $target.offset().top - $(".header").height() - 90,
            },
            500,
            "swing"
          );
      });

      $(".resource-grid .content-wrap .card-item .card-intro h4").dotdotdot({
        height: 113,
        fallbackToLetter: true,
        watch: true,
      });

      $(".resource-grid .content-wrap .card-item .card-intro p").dotdotdot({
        height: 92,
        fallbackToLetter: true,
        watch: true,
      });

      $(".resource-card .row-wrap .eight-col .card-content h3").dotdotdot({
        height: 92,
        fallbackToLetter: true,
        watch: true,
      });

      $(
        ".resource-card .row-wrap .four-col .small-card-wrapper .small-card-content h3"
      ).dotdotdot({
        height: 113,
        fallbackToLetter: true,
        watch: true,
      });
      $(".col-three-grid .column-wrapper .col-three .card-intro h4").dotdotdot({
        height: 113,
        fallbackToLetter: true,
        watch: true,
      });
    }

    // Fetch Data Using Json
    $(document).ready(function () {

      if ($(".contact-us").length > 0) {
        $("body").addClass("footer-pattern");
      }

      scroll_ani();

      if ($(".ua-safari").length > 0) {
        // Safari and mobile
        var f = 0;
        if (f === 0) {
          $(".voice-external-box .container iframe").attr(
            "src",
            "https://voice.dev.us-1.veritone.com/preview-voice-simple"
          );
          f = 1;
        }
      } else {
        if ($(".ua-mobile").length > 0) {
          // Mobile
          var f2 = 0;
          if (f2 === 0) {
            $(".voice-external-box .container iframe").attr(
              "src",
              "https://voice.dev.us-1.veritone.com/preview-voice-simple"
            );
            f2 = 1;
          }
        }
      }

    });
  });
})(jQuery);
